module.exports = __webpack_public_path__ + "img/logo-keybook.790dccea.svg";